<template>
    <div>
        <h4 class="n2-text-center">
            {{ $t('components.signin.signin_title') }}
        </h4>
        <p style="font-style:italic;" v-html="$t('components.signin.signin_desc')"></p>
        <form v-on:submit.prevent="signin">
            <form-input type="text" v-model="email" v-bind:label="$t('components.signin.email')"
                v-bind:errors="model_errors.email"></form-input>
            <form-input type="password" v-model="password" v-bind:label="$t('components.signin.password')"
                v-bind:errors="model_errors.password"></form-input>
            <!-- <form-input type="checkbox" v-model="remember_me" v-bind:label="$t('components.signin.remember_me')" v-bind:errors="model_errors.remember_me"></form-input> -->

            <validation-summary v-bind:errors="model_errors"></validation-summary>
            <div class="n2-margin-top">
                <button class="n2-button-1">{{ $t('components.signin.signin') }}</button>
            </div>
            <div style="margin:16px 0">
                <a v-bind:href="`/${app_locale}/signup`">{{ $t('components.signin.signup') }}</a>
            </div>
            <div style="margin: 16px 0 20px">
                <a v-bind:href="`/${app_locale}/forget-password`">{{ $t('components.signin.forget_password') }}</a>
            </div>
        </form>
        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { IdentityService } from '../../services'

import FormInput from "../shared/form-input.vue"
import ValidationSummary from '../shared/validation-summary.vue';
import AppLoader from '../shared/loader.vue';

export default {
    components: { FormInput, ValidationSummary, AppLoader },
    data: function () {
        return {
            model_errors: {},
            email: '',
            password: '',
            remember_me: false,
            loading: false
        };
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ])
    },
    created: function () {
        this.identityService = new IdentityService();
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}
            if (!this.email) {
                this.model_errors['email'] = [this.$t('components.signin.error_email')]
            }
            if (!this.password) {
                this.model_errors['password'] = [this.$t('components.signin.error_password')]
            }

            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
        signin: async function () {
            if (!this.validateForm()) {
                return
            }
            try {
                this.loading = true;
                await this.$store.dispatch('identity/signin', { email: this.email, password: this.password });
                // await this.identityService.signin({ email: this.email, password: this.password })
                // Cookies.set('last_active', (new Date()).toISOString(), { expires: 365 });
                // Cookies.set('authenticated', true);
                // this.$store.commit('identity/signin')

                this.email = ''
                this.password = ''
                this.closeModal()
                if (this.$route.query.redirect_url) {
                    let newPath = this.$route.query.redirect_url
                    let newQuery = this.$route.query
                    delete newQuery.redirect_url
                    this.$router.push({ path: newPath, query: newQuery })
                }
            }
            catch {
                this.model_errors = { sign_in: [this.$t('components.signin.error_sign_in')] }
            }
            finally {
                this.loading = false;
            }
        }
    }
}
</script>
<style lang="sass">
</style>
